import type { ReadonlyDeep } from 'type-fest';

import { CostTypeEnum, VariableCostInput } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';

import { codingConfigForm2ApiMapper } from '../../CodingConfig/mappers/coding-config.form2api.mapper';

import type { VariableCostInput as IVariableCostInput } from '../hooks/useCreateVariableCostMutation.hook';
import type { CostForm_VariableCost } from '../fragments/variable-cost.fragment';

export function variableCostForm2ApiMapper(
  variableCost: ReadonlyDeep<CostForm_VariableCost>,
): ReadonlyDeep<IVariableCostInput> {
  const variableCostInput = pruneInput(variableCost, VariableCostInput);

  return {
    ...variableCostInput,
    kind: CostTypeEnum.VariableCost,
    codingConfig: codingConfigForm2ApiMapper(variableCost.codingConfig),
  };
}
